export const SET_LOADING_COMPLETE = 'CardEdit/SET_LOADING_COMPLETE'
export const SET_CATEGORIES = 'CardEdit/SET_CATEGORIES'
export const SET_AUDIT_FOR_FORM = 'CardEdit/SET_AUDIT_FOR_FORM'
export const SET_TAGS = 'CardEdit/SET_TAGS'
export const SET_PICTOS = 'CardEdit/SET_PICTOS'
export const CLEAR_ALL = 'CardEdit/CLEAR_ALL'
